export function createdAtSort(eventA, eventB) {
  if (eventA.createdAt === eventB.createdAt) {
    return 0;
  }
  return eventA.createdAt < eventB.createdAt ? 1 : -1;
}
